import { setTfaRequired, setUser } from "../redux/actions/user.actions";
import { openNotificationWithIcon } from "../utils/Notification";
import { clearStorage, getItem, setItem } from "../utils/storage";
import { request } from "./verb.services";
import { setLoading } from "redux/actions/app.actions";
import { push, replace } from "connected-react-router";
import queryString from "query-string";
import { getServerErrorString } from "utils/common";

export const changePassword = (data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request("Account/Password", "patch", data, true)
      .then((response) => {
        openNotificationWithIcon(
          "success",
          "Password Updated!",
          "Password has been changed successfully"
        );
        return { status: "success" };
      })
      .catch((e, f) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          e?.response?.message ||
          e?.response?.data?.[0]?.description ||
          "Your Password is incorrect"
        );
      })
      .finally(() => dispatch(setLoading(false)));
  };
};

export const staffInviteReset = (data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/ResetPassword`, "put", data, false)
      .then(async (response) => {
        const loginData = {
          username: data.userName,
          password: data.newPassword,
        };
        await dispatch(loginUser(loginData));
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          e?.response?.data ??
          e?.response?.data?.[0]?.code ??
          "Network error has occured"
        );
        dispatch(setLoading(false));
      });
  };
};

export const loginUser = (data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request("Account/Login", "post", data, false)
      .then(async ({ data }) => {
        dispatch(setUser(data.user));
        await setItem("user", data.user);
        await setItem("tokenContainer", { token: data.token });
        dispatch(replace("/"));
      })
      .catch(async (e) => {

        const isTfaRequired = e?.response?.data?.temporaryToken
        const wasLoginSuccessful = e?.response?.data?.wasAttemptSuccessful
        if (isTfaRequired) {
          await dispatch(setTfaRequired({
            tfaRequired: true,
            temporaryToken: e?.response?.data?.temporaryToken,
            tfaEmail: e?.response?.data?.email,
            tfaPhone: e?.response?.data?.phone,
            tfaPreferredVerificationMode: e?.response?.data?.preferred2faVerificationMode,
            tfaExpiry: e?.response?.data?.expiry ?? 3,
            tfaIsPhoneNumberConfirmed: e?.response?.data?.isPhoneNumberConfirmed,
            tfaIsEmailConfirmed: e?.response?.data?.isEmailConfirmed
          }))
          await dispatch(push('/verify-tfa'))
          return
        }

        let errorMesssage = e?.response?.data?.message ?? e.message;
        if (e.response.status === 401 || e.response.status === 403) {
          errorMesssage = "Incorrect username or password";
        }
        openNotificationWithIcon(
          "error",
          "Error!",
          errorMesssage || "Network error has occured"
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const verifyUser = () => {
  return (dispatch) => {
    dispatch(setLoading(true))
    return request("Account/Verify", "get", null, true)
      .then((result) => {
        // TODO: REMOVE THIS OPTION OBJ
        const { data } = result;
        dispatch(
          setUser(
            data || {
              emai: "test@test.com",
              firstName: "Test",
              lastname: "Test",
              userName: "Test",
            }
          )
        );
        setItem(
          "user",
          data || {
            emai: "test@test.com",
            firstName: "Test",
            lastname: "Test",
            userName: "Test",
          }
        );
        return {
          status: "success",
          data: data || {
            emai: "test@test.com",
            firstName: "Test",
            lastname: "Test",
            userName: "Test",
          },
        };
      })
      .catch((e) => {
        console.log(e);
        openNotificationWithIcon(
          "error",
          "Error!",
          e?.response?.data?.message || "Unable to verify authentication token"
        );
      }).finally(() => {
        dispatch(setLoading(false))
      })
  };
};

export const resetPassword = (data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/ResetPassword`, "put", data, false)
      .then((response) => {
        openNotificationWithIcon(
          "success",
          "Success!",
          "Password has been changed successfully"
        );
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          e?.response?.data?.[0]?.code ?? "Network error has occured"
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const forgotPassword = (data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `Account/ForgotPassword?${queryString.stringify(data)}`,
      "put",
      {},
      false
    )
      .then((response) => {
        openNotificationWithIcon(
          "info",
          "Reset email sent",
          "Password reset email sent successfully"
        );
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          e?.response?.data ?? "Network error has occured"
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const resendTfaCode = (tempToken, method) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/ResendTwoFactorToken?twoFactorVerificationMode=${method}`, 'put', null, true, null, null, tempToken)
      .then((response) => {
        openNotificationWithIcon(
          "success",
          "TFA Code Sent",
          "Code has been resent"
        );
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      }
      )
      .finally(() => {
        dispatch(setLoading(false));
      })
  }
}

export const verifyTfaCode = (tempToken, code, method) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/VerifyTwoFactorToken?token=${code}&twoFactorVerificationMode=${method}`, 'put', {}, true, null, null, tempToken)
      .then(({ data }) => {
        openNotificationWithIcon(
          "success",
          "TFA Verified",
          "Two-Factor Authentication successful"
        );
        dispatch(setUser(data.user));
        setItem("user", data.user);
        setItem("tokenContainer", { token: data.token });
        dispatch(replace("/"));
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      })
  }
}

export const sendPhoneNumberConfirmationToken = (staffId, phoneNumber) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    // return request(`Staffs/${staffId}/updatePreference`, 'put', data, true,)
    //   .then(({ data }) => {
    //     return request(`Account/SendPhoneNumberConfirmationToken`, 'put', {}, true)
    //       .then(({ data }) => {
    //         openNotificationWithIcon(
    //           "success",
    //           "Phone Confirmation Sent",
    //           "Phone confirmation code sent successfully"
    //         );
    //         // TODO: update user phone in redux store
    //         return { status: "success" };
    //       }).catch(e => {
    //         openNotificationWithIcon(
    //           "error",
    //           "Error!",
    //           getServerErrorString(e)
    //         );
    //       })
    //   })
    return request(`Account/SendPhoneNumberConfirmationToken?phoneNumber=${phoneNumber}`, 'put', {}, true)
      .then(({ data }) => {
        openNotificationWithIcon(
          "success",
          "Phone Confirmation Sent",
          "Phone confirmation code sent successfully"
        );
        // TODO: update user phone in redux store
        return { status: "success" };
      }).catch(e => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      })
  }
}

export const resendPhoneConfirmationToken = (staffId, phoneNumber) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/SendPhoneNumberConfirmationToken?phoneNumber=${phoneNumber}`, 'put', {}, true)
      .then(({ data }) => {
        openNotificationWithIcon(
          "success",
          "Phone Confirmation Sent",
          "Phone confirmation code sent successfully"
        );
        // TODO: update user phone in redux store
        return { status: "success" };
      }).catch(e => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      }).finally(() => {
        dispatch(setLoading(false))
      })
  }
}

export const verifyPhoneConfirmationToken = (token = "", phoneNumber = "") => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/ConfirmPhoneNumberVerification?token=${token}&phoneNumber=${phoneNumber}`, 'put', {}, true)
      .then(({ data }) => {
        openNotificationWithIcon(
          "success",
          "Token Confirmed",
          "Phone Two-Factor Authentication has been configured successfully"
        );
        // TODO: update user phone in redux store
        return { status: "success" };
      }).catch(e => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      }).finally(() => {
        dispatch(setLoading(false))
      })
  }
}

export const sendEmailConfirmationToken = (staffId, email) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/ChangeEmailToken?newEmail=${email}`, 'get', null, true,).then(({ data }) => {
      openNotificationWithIcon(
        "success",
        "Email Confirmation Sent",
        "Email confirmation code sent successfully"
      );
      // TODO: update user email in redux store
      return { status: "success" };
    })
      // .then(({ data }) => {
      //   return request(`Account/SendEmailConfirmationToken`, 'put', {}, true)
      //     .then(({ data }) => {
      //       openNotificationWithIcon(
      //         "success",
      //         "Email Confirmation Sent",
      //         "Email confirmation code sent successfully"
      //       );
      //       // TODO: update user email in redux store
      //       return { status: "success" };
      //     }).catch(e => {
      //       openNotificationWithIcon(
      //         "error",
      //         "Error!",
      //         getServerErrorString(e)
      //       );
      //     })
      // })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      })
  }
}

export const resendEmailConfirmationToken = (staffId, email) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/ChangeEmailToken?newEmail=${email}`, 'get', null, true,).then(({ data }) => {
      openNotificationWithIcon(
        "success",
        "Email Confirmation Sent",
        "Email confirmation code sent successfully"
      );
      // TODO: update user email in redux store
      return { status: "success" };
    }).catch(e => {
      openNotificationWithIcon(
        "error",
        "Error!",
        getServerErrorString(e)
      );
    }).finally(() => {
      dispatch(setLoading(false))
    })
  }
}

export const verifyEmailConfirmationToken = (token = "", email = "") => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Account/ChangeEmailToken?otp=${token}&newEmail=${email}`, 'patch', {}, true)
      .then(({ data }) => {
        openNotificationWithIcon(
          "success",
          "Token Confirmed",
          "Email Two-Factor Authentication has been configured successfully"
        );
        clearStorage();
        dispatch({ type: "RESET" });
        dispatch(replace("/"));
        // TODO: update user phone in redux store
        return { status: "success" };
      }).catch(e => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      }).finally(() => {
        dispatch(setLoading(false))
      })
  }
}

export const changeTFAPreference = (staffId, data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`Staffs/${staffId}/updatePreference`, 'put', data, true,)
      .then(({ data }) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Two-Factor Authentication preference changed successfully"
        );
        return { status: 'success' }
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      })
  }
}